<template>
  <v-row align="start" justify="end" :class="classPadding" v-if="photoSrc">
    <!-- <v-col cols="12" xs="12" sm="3" md="3" :class="classPadding">
      <v-img
        v-bind:src="photoSrc"
        width="100"
        height="100"
        class="text-center"
        contain
        v-if="imageLoaded"
        :class="classPadding"
      ></v-img>
    </v-col>-->
    <v-card class="elevation-0" width="144" :class="classPadding">
      <v-card-text class="text-center" :class="classPadding">
        <v-img
          v-bind:src="photoSrc"
          width="90"
          height="90"
          class="text-center"
          contain
          v-if="imageLoaded"
          :class="classPadding"
        ></v-img>
      </v-card-text>
    </v-card>
  </v-row>
</template>
<script>
import { isNullOrUndefined } from "../../../../validation/validation";
export default {
  props: ["empCode"],
  data: () => ({
    classPadding: "my-0 py-0",
    imageLoaded: false,
    empImage: null
  }),
  computed: {
    // ...mapState("personalInfo", ["employeeImage"]),
    // imageSrc() {
    //   if (this.emp.sex == "M") {
    //     return this.imageSrcMale;
    //   } else if (this.emp.sex == "F") {
    //     return this.imageSrcFemale;
    //   } else {
    //     return "";
    //   }
    // },
    photoSrc() {
      if (isNullOrUndefined(this.empImage) || this.empImage == "") {
        return "";
      } else {
        return "data:image/jpeg;base64," + this.empImage;
      }
    }
  },
  methods: {
    // ...mapActions("personalInfo", ["setImage"]),
    getImage(empCode) {
      this.imageLoaded = false;
      this.$axios
        .get(`/api/personalInfo/image/${empCode}`)
        .then(({ data }) => {
          this.empImage = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.imageLoaded = true;
        });
    }
  },
  watch: {
    empCode(val) {
      if (!isNullOrUndefined(val)) {
        this.getImage(val);
      } else {
        this.empImage = null;
      }
    }
  },
  created() {
    this.getImage(this.empCode);
  }
};
</script>